import React, { useEffect, useState } from "react";
import { getUserLeaveData } from "../../api";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ROLE } from "../../config";
import Cookies from "universal-cookie";
import Moment from "react-moment";
import { EyeIcon, PencilAltIcon, XIcon } from "@heroicons/react/solid";
import ZoomImage from "../../components/ZoomImage";
import { Modal } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import RoundedContainer from "../../components/containers/RoundedContainer";
import { Button } from "../../components/ui";
import { ClockIcon } from "@heroicons/react/solid";
import UtilizedLeavesModal from "../../components/modals/UtilizedLeavesModal";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import InlineLoader from "../../components/loader/InlineLoader";

const cookies = new Cookies();

const breadcrumbs = [
  { label: "Dashboard", link: "/" },
  { label: "Leaves Applied", link: "/leaves-applied" },
];

const UserLeaves = () => {
  const [role, setRole] = useState("");
  useEffect(() => {
    setRole(cookies.get(ROLE));
  }, []);
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [leaveInfo, setLeaveInfo] = useState("");
  const [leaveData, setLeaveData] = useState([]);
  const [userId, setUserId] = useState("");
  const [singleLeaveData, setSingleLeaveData] = useState({});
  const [isOpenDocumentModal, setIsOpenDocumentModal] = useState(false);
  const [isUtilizedModalOpen, setIsUtilizedModalOpen] = useState(false);

  useEffect(() => {
    handleGetUserLeaveData();
  }, []);

  const handleGetUserLeaveData = () => {
    setIsLoading(true);
    getUserLeaveData(id)
      .then((res) => {
        if (res.status === 200) {
          setLeaveData(res.data.data);
          setLeaveInfo(res.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        alert("something went wrong please refresh");
        setIsLoading(false);
      });
  };

  const handleFetchUserDocuments = (id) => {
    setUserId(id);
    setSingleLeaveData(leaveData.find((data) => data.id === id));
    setIsOpenDocumentModal(true);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 pb-20">
      <div className="mb-4">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>
      {isLoading ? (
        <div className="flex flex-col items-center justify-center py-16">
          <InlineLoader className="text-primary w-8 h-8" />
          <span className="text-gray-500 text-sm mt-3 font-medium">
            Loading leaves...
          </span>
        </div>
      ) : (
        <div>
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Leaves Applied</h1>
            <Button
              type="button"
              variant="outline"
              onClick={() => setIsUtilizedModalOpen(true)}
              className="flex items-center gap-2 self-start sm:self-auto border-gray-300 hover:bg-gray-50 text-gray-700 shadow-sm"
            >
              <ClockIcon className="w-4 h-4 text-primary" />
              <span>View Utilized Leaves</span>
            </Button>
          </div>
          <div className="grid grid-cols-4 gap-x-4 mt-4">
              {leaveInfo.pending_pl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_pl_leave}/${leaveInfo.applicable_pl}`}</h1>
                  <h3 className="text-lg font-semibold">PL Available</h3>
                </div>
              )}

              {leaveInfo.pending_cl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_cl_leave}/${leaveInfo.applicable_cl}`}</h1>
                  <h3 className="text-lg font-semibold">CL Available</h3>
                </div>
              )}

              {leaveInfo.pending_sl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_sl_leave}/${leaveInfo.applicable_sl}`}</h1>
                  <h3 className="text-lg font-semibold">SL Available</h3>
                </div>
              )}

              {leaveInfo.pending_ol_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_ol_leave}/${leaveInfo.applicable_ol}`}</h1>
                  <h3 className="text-lg font-semibold">OL Available</h3>
                </div>
              )}

              {leaveInfo.pending_dl_leave && (
                <div className="bg-orange-700 text-white text-center py-5 rounded">
                  <h1 className=" text-2xl font-semibold">{`${leaveInfo.pending_dl_leave}/${leaveInfo.applicable_dl}`}</h1>
                  <h3 className="text-lg font-semibold">DL Available</h3>
                </div>
              )}
            </div>
            {leaveData.length <= 0 ? (
              <div className="text-center">
                <p className=" text-gray-700 text-3xl">No Leaves To Show</p>
              </div>
            ) : (
              <div className="max-w-full overflow-x-auto mt-8">
                <RoundedContainer>
                  <Table className="table-auto w-full">
                    <TableHead>
                      <TableHeaderCell className="w-[8%] text-center">
                        Sr.no
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[20%] text-center">
                        Dates
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[22%]">
                        Reason
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[14%] text-center">
                        Leave Type
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[12%] text-center">
                        Status
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[12%] text-center">
                        Document
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[12%] text-center">
                        Action
                      </TableHeaderCell>
                    </TableHead>
                    <TableBody>
                      {leaveData?.map((data, idx) => {
                        const { id } = data;
                        return (
                          <TableRow key={idx}>
                            <TableCell className="text-center text-dark font-medium text-sm">
                              {idx + 1}
                            </TableCell>
                            <TableCell className="text-center text-dark font-medium text-sm">
                              <span className="px-2 py-0.5 rounded bg-gray-100 text-gray-700 text-xs block mb-1">
                                From:{" "}
                                <Moment unix format="DD/MM/YYYY">
                                  {data.from_date}
                                </Moment>
                              </span>
                              {data.to_date !== "0" && (
                                <span className="px-2 py-0.5 rounded bg-gray-100 text-gray-700 text-xs block">
                                  To:{" "}
                                  <Moment unix format="DD/MM/YYYY">
                                    {data.to_date}
                                  </Moment>
                                </span>
                              )}
                            </TableCell>
                            <TableCell className="text-dark font-medium text-sm">
                              {data.reason}
                            </TableCell>
                            <TableCell className="text-center text-dark font-medium text-sm capitalize">
                              {data.leave_type}
                            </TableCell>
                            <TableCell className="text-center">
                              {data.leave_status === "1" ? (
                                <span className="bg-green-100 text-green-700 font-medium px-2.5 py-1 rounded-full text-xs">
                                  Approved
                                </span>
                              ) : data.leave_status === "2" ? (
                                <span className="bg-yellow-100 text-yellow-700 font-medium px-2.5 py-1 rounded-full text-xs">
                                  Pending
                                </span>
                              ) : (
                                <span className="bg-red-100 text-red-700 font-medium px-2.5 py-1 rounded-full text-xs">
                                  Rejected
                                </span>
                              )}
                            </TableCell>
                            <TableCell className="text-center">
                              {data.file_list ? (
                                <div className="flex items-center justify-center w-full">
                                  <Button
                                    variant="default"
                                    size="sm"
                                    type="button"
                                    onClick={() =>
                                      handleFetchUserDocuments(data.id)
                                    }
                                    className="flex items-center space-x-1 justify-center"
                                  >
                                    <EyeIcon className="w-4 h-4" />{" "}
                                    <span>View</span>
                                  </Button>
                                </div>
                              ) : (
                                "---"
                              )}
                            </TableCell>
                            <TableCell className="text-center text-dark font-medium text-sm">
                              <div className="flex items-center justify-center space-x-3">
                                {data.leave_edited && (
                                  <Link
                                    to={{
                                      pathname: `/leaves/leave-edit-history/${id}`,
                                    }}
                                    className="flex items-center justify-center text-gray-500 hover:text-primary transition-colors"
                                  >
                                    <EyeIcon className="w-5 h-5" />
                                  </Link>
                                )}
                                {role === "EMPLOYEE" ||
                                role === "CONSULTANT" ? (
                                  "---"
                                ) : (
                                  <Link
                                    to={{
                                      pathname: `/edit-leaves/${id}`,
                                      state: { data },
                                    }}
                                    state={data}
                                    className="flex items-center justify-center text-gray-500 hover:text-primary transition-colors"
                                  >
                                    <PencilAltIcon className="w-5 h-5" />
                                  </Link>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </RoundedContainer>
              </div>
            )}
          </div>
        )}
        <Modal
          open={isOpenDocumentModal}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[20%]">
            <div className="document-wrapper px-4 divide-y">
              <div className="document-head py-4">
                <div className="flex items-center justify-between">
                  <h3 className=" text-gray-700 text-3xl font-semibold">
                    Documents
                  </h3>
                  <div
                    className=" w-6 h-6 cursor-pointer"
                    onClick={() => setIsOpenDocumentModal(false)}
                  >
                    <XIcon className=" text-black w-full h-full" />
                  </div>
                </div>
              </div>
              <div className="document-body py-4 max-h-96 overflow-auto">
                {singleLeaveData?.file_list?.length <= 0 ? (
                  <div className="text-center my-4">
                    <p className="text-gray-700 text-2xl">
                      No Document To Show
                    </p>
                  </div>
                ) : (
                  <div className="grid grid-cols-4 gap-4">
                    {singleLeaveData?.file_list?.map((data, idx) => {
                      const { file_name, document_media_type } = data;
                      return (
                        <>
                          {document_media_type === "pdf" ? (
                            <a
                              href={file_name}
                              target="_blank"
                              rel="noopener noreferrer"
                              className=" text-center py-2 px-2 rounded bg-gray-400 text-gray-700"
                            >
                              View PDF
                            </a>
                          ) : (
                            <ZoomImage key={idx} className="h-full">
                              <img
                                src={file_name}
                                alt="dummy"
                                className="border-2 border-black w-full h-full"
                              />
                            </ZoomImage>
                          )}
                        </>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="document-foot space-x-4 py-4">
                <Button
                  variant="outline"
                  onClick={() => setIsOpenDocumentModal(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        <UtilizedLeavesModal
          isOpen={isUtilizedModalOpen}
          onClose={() => setIsUtilizedModalOpen(false)}
        />
    </div>
  );
};

export default UserLeaves;
